import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//Material
import { Avatar, Box, Grid, Menu, MenuItem, Tooltip, Typography } from '@mui/material';

import { connect, useDispatch, useSelector } from 'react-redux';
import { setIsOpenUserContactsModal } from '../redux/mainReducer';
import DefaultAvatar from '../assets/defaultPostImg.jpg';
import { base } from '../redux/thunk';
import ApiService from '../helpers/apiHelper';
import { ChatBubbleOutline, MoreHoriz } from '@mui/icons-material';

function UserCardReader({
  isNavigate = true,
  isResendMessage,
  selectedUsers,
  setSelectedUsers,
  user,
  language,
  userData,
  getUserSubscriptionsThunk,
  getUserSubscribersThunk,
  getBlockedUsersThunk,

  subscriptions,
  setter,
  blockedUsers
}) {
  const apiSubscribe = new ApiService('auth/subscribe');
  const apiUnSubscribe = new ApiService('auth/unsubscribe');
  const apiChats = new ApiService('notification/chats');

  // const apiBU = new ApiService('/blocked-users');
  const apiBU = new ApiService('auth/blocked-users');
  const isOpenResendingModal = useSelector((state) => state.global.isOpenResendingModal);

  // const apiChats = new ApiService('chats');
  const params = useParams();
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  // eslint-disable-next-line
  const handleChange = (event) => {
    if (selectedUsers.includes(user.id)) {
      setSelectedUsers(selectedUsers.filter((id) => user.id !== id));
    } else {
      setSelectedUsers([...selectedUsers, user.id]);
    }
  };

  return (
    <Grid
      container
      spacing={0}
      sx={{
        boxShadow:
          !window.location.href.includes('ribbon') ||
          (window.location.href.includes('ribbon') && isOpenResendingModal.isOpen)
            ? '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
            : 'none',

        padding: '8px',
        marginBottom: !window.location.href.includes('ribbon') ? '10px' : '5px',
        justifyContent: {
          xs: blockedUsers.find((el) => el.id === user.id) ? 'start' : 'space-between',
          sm: 'space-between'
        },
        alignItems: 'center',
        background: 'white',
        zIndex: 9999,
        position: 'relative',
        borderRadius: '8px',
        minHeight: { xs: '76px', sm: '96px' },
        maxHeight: {
          xs: blockedUsers.find((el) => el.id === user.id) ? '114px' : '92px',
          sm: '106px'
        }
      }}
    >
      <Grid item xs={2.5} sm={2} sx={{ display: 'flex', alignItems: 'center' }}>
        <Avatar
          onClick={() => {
            if (isNavigate) {
              dispatch(setIsOpenUserContactsModal(false));

              navigate(`/${language}/user-page/${user.id}?type=posts`);
            }
          }}
          src={user?.photoUrl ? `${user?.photoUrl}` : DefaultAvatar}
          sx={{
            width: { xs: 60, sm: 70 },
            height: { xs: 60, sm: 70 },
            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
            cursor: 'pointer'
          }}
        />
      </Grid>
      <Grid
        item
        xs={6}
        sm={6.5}
        sx={{
          display: 'flex',
          alignItems: 'left',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        <Typography
          variant="subtitle"
          sx={{
            fontFamily: 'FixelText-Medium !important',
            fontSize:
              user?.name && user.surname ? { xs: '14px', sm: '16px' } : { xs: '14px', sm: '18px' },
            lineHeight: { xs: '24px', sm: '26px' },
            textAlign: 'left',
            cursor: 'pointer',
            fotWeight: '500',
            color: '#7C7C7C'
          }}
          onClick={() => {
            if (isNavigate) {
              dispatch(setIsOpenUserContactsModal(false));
              navigate(`/${language}/user-page/${user.id}?type=posts`);
            }
          }}
          src={user?.photoUrl ? `${user?.photoUrl}` : DefaultAvatar}
        >
          {`@${user?.nickname}`}
        </Typography>
        {user?.name && user?.surname && (
          <>
            <Typography
              variant="subtitle"
              sx={{
                fontFamily: 'FixelText-Medium !important',
                fontSize: { xs: '16px', sm: '20px' },
                textAlign: 'left',
                cursor: 'pointer'
              }}
              onClick={() => {
                if (isNavigate) {
                  dispatch(setIsOpenUserContactsModal(false));
                  navigate(`/${language}/user-page/${user.id}?type=posts`);
                }
              }}
              // src={
              //   user?.encodedMediaDTO
              //     ? `data:${user?.encodedMediaDTO.contentType};base64, ${user?.encodedMediaDTO.encodedContent}`
              //     : DefaultAvatar
              // }
            >
              {`${user?.name} ${user?.surname}`}
            </Typography>
          </>
        )}
      </Grid>
      <Grid
        item
        xs={blockedUsers.find((el) => el.id === user.id) ? 12 : 3.5}
        sm={3.5}
        sx={{
          display: 'flex',
          justifyContent: blockedUsers.find((el) => el.id === user.id) ? 'center' : 'end',
          alignItems: 'center'
        }}
      >
        {subscriptions.find((subscription) => subscription.id === user.id) && (
          <Tooltip title="Написати">
            <ChatBubbleOutline
              onClick={() => {
                apiChats
                  .postDataQuery({
                    userId: userData.id,
                    recipientId: user.id
                  })
                  .then((res) => {
                    dispatch(setIsOpenUserContactsModal(false));
                    navigate(`/${language}/messages`);
                    setter();
                  })
                  .catch((error) => {
                    if (error?.message.includes('There is a chat between these users')) {
                      const id = `${error.message.slice(
                        error.message.indexOf('[') + 1,
                        error.message.length - 1
                      )}`;

                      navigate(`/${language}/messages?chatId=${id}`);
                      setter();
                      dispatch(setIsOpenUserContactsModal(false));
                    }
                  });
              }}
              sx={{ color: '#60A5DF', cursor: 'pointer', zIndex: 99 }}
            />
          </Tooltip>
        )}

        {params.id && !blockedUsers.find((el) => el.id === user.id) && (
          <Box
              id="positioned-button"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: { xs: '24px', sm: '40px' },
              height: { xs: '24px', sm: '40px' },
              backgroundColor: 'white',
              cursor: 'pointer',
              boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
              borderRadius: '50px',
              ml: { xs: '8px', ml: '24px' },

              zIndex: 102
            }}
          >
            <MoreHoriz
              onClick={(event) => handleClick(event)}
              sx={{ cursor: 'pointer', zIndex: 102 }}
            />
          </Box>
        )}
        {blockedUsers.find((el) => el.id === user.id) && (
          <Box
            sx={{
              backgroundColor: '#FFE5E5',
              cursor: 'pointer',
              padding: '6px 12px',
              borderRadius: '8px',
              color: '#F64D36',
              fontSize: '14px',
              fontWeight: '500',
              zIndex: 102
            }}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              apiBU.deleteItemQuery({ blockedUserId: user?.id }).then((res) => {
                getBlockedUsersThunk();
                getUserSubscriptionsThunk(userData?.id);
                getUserSubscribersThunk(userData?.id);
                handleClose();
              });
            }}
          >
            Розблокувати
          </Box>
        )}

        <Menu
          anchorEl={anchorEl}
          id="action-menu"
          open={open}
          onClose={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'hidden',
              boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
              borderRadius: '5px',
              border: '1px solid #F5F4F4',
              paddingTop: '10px',
              paddingLeft: '20px',
              paddingRight: '20px',
              width: '270px',
              mt: 1,
              height: 'fit-content'
            }
          }}
          autoFocus={false}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();

              window.open(
                `${window.location.origin}/${language}/user-page/${user.id}?type=services`
              );
            }}
            sx={{
              fontWeight: '500',
              padding: '4px 12px',
              borderRadius: '4px',
              ':hover': {
                backgroundColor: '#E2F2FF'
              },
              mb: { xs: 0, sm: 2 }
            }}
          >
            <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
              Перейти у профіль
            </Typography>
          </MenuItem>
          {userData?.id !== user.id && !blockedUsers.find((el) => el.id === user.id) && (
            <MenuItem
              onClick={() => {
                if (subscriptions.find((subscription) => subscription.id === user.id)) {
                  apiUnSubscribe.deleteItemQuery({ subscriptionId: user.id }).then((res) => {
                    getUserSubscriptionsThunk(userData.id);
                  });
                } else {
                  apiSubscribe.updateDataQuery({ subscriptionId: user.id }).then((res) => {
                    getUserSubscriptionsThunk(userData.id);
                  });
                }
              }}
              sx={{
                fontWeight: '500',
                padding: '4px 12px',
                borderRadius: '4px',
                ':hover': {
                  backgroundColor: '#E2F2FF'
                },
                mb: { xs: 0, sm: 2 }
              }}
            >
              <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
                {subscriptions.find((subscription) => subscription.id === user.id)
                  ? 'Видалити з контактів'
                  : 'Підписатись'}
              </Typography>
            </MenuItem>
          )}

          {userData?.id !== user.id && !blockedUsers.find((el) => el.id === user.id) && (
            <MenuItem
              sx={{
                fontWeight: '500',
                padding: '4px 12px',
                borderRadius: '4px',
                ':hover': {
                  backgroundColor: '#FFE5E5',
                  color: '#F64D36'
                },
                mb: { xs: 0, sm: 1 }
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                apiBU.updateDataQueryPost({ blockedUserId: user?.id }).then((res) => {
                  getBlockedUsersThunk();
                  getUserSubscriptionsThunk(userData?.id);
                  getUserSubscribersThunk(userData?.id);
                  handleClose();
                });
              }}
            >
              <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
                Заблокувати
              </Typography>
            </MenuItem>
          )}
        </Menu>
      </Grid>
    </Grid>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    subscriptions: state.global.userSubscriptions,
    blockedUsers: state.global.blockedUsers
  };
};
export default connect(mapStateToProps, {
  getUserSubscribersThunk: base.getUserSubscribersThunk,
  getUserSubscriptionsThunk: base.getUserSubscriptionsThunk,
  getBlockedUsersThunk: base.getBlockedUsersThunk,
  getMutedUsersThunk: base.getMutedUsersThunk
})(UserCardReader);
